module.exports={
    products: {
    	commodityManage:'商品管理',
    	search:'検索する',
    	import:'インポート',
        download:'ダウンロード',
    	add:'追加',
		delete:'削除する',
		submiting: '提出中...',
    	table1:{	//商品管理表格
            barcode:'バーコード',
    		index:'番号',
            name:'商品名',
    		brand:'ブランド',
    		specification:'規格',
            price:'価格',
    		status:'状態',
            statusUnbound:'未绑定',
			statusBind:'已绑定',
			statusUnbound1:'アンバウンド',
            statusBind1:'バウンド',
    		operation:'運営',
    		delete:'削除する'
    	},
    	commodityDetails:'商品詳細',
    	form1:{		//商品详情表单
    		proNo:'商品番号：',
    		name:'商品名：',
    		proAbbr:'製品の略称：',
    		price:'価格：',
    		brand:'ブランド：',
    		specification:'規格：',
    		rating:'ランク：',
    		piece:'単位：',
    		origin:'産地：',
            supplierName:'ベンダー：',
    		barcode:'バーコード：',
    		qrcode:'QRコード：',
    		save:'保存',
            hint:'商品を選択してください',
            success:'商品の変更が成功し、棚札更新の指示が正常に送信されました。後でページを更新して最新のデータを取得してください',
            fail:'商品の変更に失敗しました',
            fail0:'商品の変更に成功し、棚札の更新に失敗しました',
            fail1:'商品の変更に失敗しました。棚札はゲートウェイに連携されていません',
            fail2:'商品の変更に失敗しました。対応する棚札はインポートされませんでした',
            fail3:'商品の変更に失敗しました。連携された棚札に空のテンプレートがあります',
            fail4:'商品の変更は成功し、棚札の更新は失敗し、商品には結合棚札がありません',
            fail5:'商品の変更は成功し、棚札の更新は失敗し、棚札によって連携されたテンプレートは存在しません',
            noPermission:'商品の変更に失敗しました、権限がありません',
            label:'棚札 ',
            length:'{num}文字以内',
            barcodeLen:'長さは13桁',
            unfold:'展開する',
            fold:'閉じる'
    	},
    	preview:'プレビューを表示',
    	bindTag:'棚札と連携',
    	table2:{     //绑定标签表格
    		mac:'Macアドレス',
    		demoName:'テンプレート',
    		status:'状態',
            statusSucceeded:'正常に更新されました',
            // statusSucceeded1:'更新成功',
            statusFailed:'更新できませんでした',
            // statusFailed1:'更新失败',
    		operation:'運営',
    		delete:'削除する',
    		push:'再プッシュ',
    		update:'修正',
    	},
    	dialogAdd:{   //商品管理-新增弹框
    		dialogTitle:'追加',
    		proNo:'商品番号',
    		name:'商品名',
    		proAbbr:'製品の略称',
    		price:'価格',
    		brand:'ブランド',
    		specification:'規格',
    		rating:'ランク',
    		piece:'単位',
    		origin:'産地',
    		barcode:'バーコード',
    		qrcode:'QRコード',
            supplierName:'サプライヤー',
    		cancel:'キャンセル',
    		sure:'確定',
            addProSuccess:'商品追加成功',
            addProFail:'商品を追加できませんでした',
            noPermission:'商品を追加できませんでした。権限がありません',
            alreadyExists:'追加されたアイテム'

        },
        dialogExport:{
            more:"詳細",
            allExport:"すべてエクスポート",
            partExport:"エクスポート",
            dialogTitle:"エクスポート",
            dialogMsgAll:"すべての商品を確実にエクスポートしますか?",
            dialogMsgPart:"選択した商品をエクスポートしますか?",
            hint:"まずエクスポートする商品を選んでください！",
            errorMsg:"商品のエクスポートに失敗しました！"
        },
        dialogRgb:{
            rgbSet:"RGBランプ設定",
            timeRgb:"RGBランプ点灯時間:",
            colorRgb:"RGBライト点灯色:",
            setIlluminate:"RGBライトの明るさ:",
            selectTime:"時間を選んでください",
            openRgb:"点灯",
            shutRgb:"消灯",
            Red:"赤",
            Gre:"緑",
            Blu:"青",
            hint:"操作する商品をチェックしてください",
            successHit:'RGBランプの設定に成功しました',
            noBind:"バインディングゲートウェイがありません"   ,
            noLable:"このラベルがありません",
            warHit:"RGBランプの設定に失敗しました" ,
            getawayoffLine:"ゲートウェイオンライン",
            checkTime:"長すぎる点灯時間は電池のロスを加速させます。",
            label:'棚札 ',
            successOpenAll:'全てを点灯するコマンドを送信成功',
            errorOpenAll:'すべてのラベル照明コマンドを送信できませんでした',
            successOpenPart:'一部を点灯するコマンドを送信失敗',
            successShutAll:"全てを点灯するコマンドを送信成功",    
            successShutPart:"一部を点灯するコマンドを送信失敗",  
            errorShutAll:"すべてのタグの消灯コマンドを送信できませんでした",
            failList:"失敗リスト",
            cardNoLable:"この商品は紐付けされていません。まずラベルを縛ってください"
        },
    	dialogDelAll:{ //商品管理-删除选中全部弹框
    		dialogTitle:'削除する',
    		dialogMsg:'選択した商品を削除してもよろしいですか',
            hint:'最初に削除する商品を選択してください',
            deleteSuccess:'バッチで商品を正常に削除しました',
            deleteFail:'アイテムを一括で削除できませんでした',
            noPermission:'許可なく商品を一括削除できませんでした'
    	},
    	dialogDel1:{ //商品管理-删除弹框
    		dialogTitle:'削除する',
    		dialogMsg:'ID {id}の商品を削除してもよろしいですか',
            success:'商品が正常に削除されました',
            fail:'商品を削除できませんでした',
            noPermission:'商品を削除できませんでした。権限がありません'
    	},
    	dialogSave:{ //商品详情-保存弹框
    		dialogTitle:'保存',
    		dialogMsg:'保存してもよろしいですか',
    	},
    	dialogDel2:{ //绑定标签-删除弹框
    		dialogTitle:'削除する',
    		dialogMsg:'{mac}を削除してもよろしいですか',
    	},
    	dialogPush:{ //绑定标签-重推弹框
    		dialogTitle:'再プッシュ',
    		dialogMsg:'{mac}を再プッシュしてもよろしいですか',
            // updateSuccess:'更新成功',
            // updateFail:'更新失败',
            hint:'棚札が初プッシュされていません。プッシュ機能を操作してください',
            successMsg1:'現在の棚札デバイスは正常に更新されたため、再プッシュする必要はありません。',
            pushSuccess:'再プッシュに成功しました',
            pushFail:'再プッシュに失敗しました',
            updateSuccess2:'デバイスは正常に更新されました。ページを更新して最新のデータを取得してください',
            noTemplate:'テンプレートは存在しません',
            noGateway:'連携されたゲートウェイは、このストアのゲートウェイではありません',
            noBind:'棚札はゲートウェイに連携されていません'

    	},
    	dialogUpdate:{ //绑定标签-修改弹框
    		dialogTitle:'修正',
    		mac:'Macアドレス',
    		demoName:'テンプレート',
            chooseTemplate:'テンプレートを選択してください',
    		cancel:'キャンセル',
    		sure:'確定',
            getTemplateFail:'このサイズのすべてのテンプレートを取得できませんでした！ もう一度やってください',
            success:'棚札と連携されたテンプレートを正常に変更します',
            fail:'棚札と連携されたテンプレートを変更できませんでした',
			bindGateway:'まずデバイスをゲートウェイに連携してください',
			tip:'現在の棚札はゲートウェイに連携されていません。この機能を操作する前にゲートウェイに連携してください',
            noTemplate:'テンプレートは存在しません',
            noGateway:'連携されたゲートウェイは、このストアのゲートウェイではありません',
            problemTemplate:'棚札に連携されているテンプレートが正しくありません。正しいテンプレートを再連携してください',
            noTemplates:'一致するテンプレートがありません。対応するタイプのテンプレートを追加してください'

    	},
        queryLabel:{ //绑定标签-查询标签
            fail:'商品に連携された棚札の検索に失敗しました',
            msg:'この商品と棚札の連携がありません'
        },
        queryProduct:{ //查询商品
            fail:'商品の検索に失敗しました'
        },
        getPrefix:{ //获取标签前缀
            fail:'棚札プレフィックスを取得できませんでした'
        },
        unbind:{
            success:'商品の連携を解除し、棚札を付ける',
            fail:'商品と棚札の連携を解除できませんでした'
        },
        labelLight:{   //标签灯
            green1:'/static/images/label_green_1.png',
            green2:'/static/images/label_green_2.png',
            blue1:'/static/images/label_blue_1.png',
            blue2:'/static/images/label_blue_2.png',
            red1:'/static/images/label_red_1.png',
            red2:'/static/images/label_red_2.png'
        },
        labelLightMsg:{   //标签灯提示信息
            green:'緑の光',
            red:'レッドライト',
            blue:'明るい青色光',
            success:'棚札 {mac}：{color}コマンドが正常に送信されました',
            fail:'棚札 {mac}：{color}コマンドの送信に失敗しました',
            unbind:'棚札 {mac}：現在の棚札はゲートウェイに連携されていません',
            noLabel:'棚札 {mac}：現在の棚札は存在しません',
            chooseLabel:'点灯する棚札を選択してください',
            color:[{
                key:'1',
                value:'ブルーライト'
            },{
                key:'2',
                value:'青信号'
            },{
                key:'3',
                value:'赤信号'
            }]
        },
        cancel:'キャンセル',
        sure:'確定',
        hint:'ヒント',
        checkout:{
            formatAndDecimals1:'正しい形式を入力してください',
            formatAndDecimals2:'小数点第2位まで',
            id:'IDを入力してください',
            length:'13桁を入力してください',
            productAdd:'追加されたアイテム',
            fail:'失敗しました。再入力してください',
            proNo:'文字または数字を入力してください'
        },
        upload:{
            format:'アップロードされるファイルはExcelスプレッドシートのみです',
            success:'商品のインポートに成功し、{success}しました',
            fail:'商品をインポートできませんでした',
            incorrectFormat:'ファイル形式が正しくありません',
            parseFail:'ファイルの解析に失敗しました',
            noPermission:'商品をインポートできませんでした。権限がありません'
        },
        timeSet:[{lab:'1分間',val:'60'},{lab:'30分間',val:'1800'},{lab:'1時間',val:'3600'},{lab:'2時間',val:'7200'},{lab:'4時間',val:'14400'},{lab:'8時間',val:'28800'},{lab:'12時間',val:'43200'}],
        // permission:{  //数据库数据，判断权限，不可改动
        //     addPro:'新增商品',
        //     delPro:'删除商品',
        //     updatePro:'修改商品'
        // }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/products.js